<template>
  <modal
    size="lg"
    title="Keyboard Shortcuts"
    id="keyMapModal"
    ref="modal"
    :show="value"
    @hidden="$emit('input', false)"
    :scrollable="false"
    :hide-footer="true"
  >
    <div v-for="(config, index) in keyMapConfigs" :key="index" :class="{ 'mt-3': index > 0 }">
      <div class="font-weight-bold mb-2">{{ titleMap[config.name] || config.description }}</div>
      <div
        class="row px-2 py-1"
        v-for="(meta, action, index) in getConfigList(config.meta)"
        :key="index"
      >
        <div class="col-9">{{ meta.description }}</div>
        <div class="col-3">
          <span
            class="badge mr-1 text-small"
            v-for="(key, index) in getActionKeys(action)"
            :key="index"
          >
            {{ key }}
          </span>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { KEYMAP_DATA } from '../services/keymapService/keymapService'
import * as R from 'ramda'
import prettifyKey from '@/utils/prettifyKey'

const titleMap = {
  global: 'Global Shortcuts',
  goals: 'Goals List Shortcuts',
  'edit-goal': 'Edit Goal Shortcuts',
  goal: 'Goal Details Page Shortcuts',
  kr: 'KR (Initiatives List) Page Shortcuts',
  initiative: 'Initiative Page Shortcuts'
}

export default {
  name: 'KeyMap',
  props: ['value'],
  components: { Modal },
  data() {
    return {
      titleMap,
      keyMapData: KEYMAP_DATA
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(isVisible) {
        this.$emit('input', isVisible)
      }
    },
    keyMapConfigs() {
      const activeCategories = this.keyMapData.ACTIVE_CATEGORIES
      const globalConfig = activeCategories.find(x => x.name === 'global')
      const sidebarConfig = activeCategories.find(x => x.name === 'sidebar')
      const topConfigs = [globalConfig, sidebarConfig].filter(Boolean)
      return topConfigs.length > 0
        ? [
            ...topConfigs,
            ...activeCategories.filter(x => !['global', 'sidebar'].some(name => x.name === name, x))
          ]
        : activeCategories
    }
  },
  methods: {
    getConfigList(meta) {
      return R.pickBy(val => val.shouldList !== false, meta)
    },
    getActionKeys(action) {
      const getKey = R.compose(
        R.nth(0),
        R.find(([, actions]) => actions.indexOf(action) > -1),
        R.toPairs
      )
      const key = getKey(this.keyMapData.ACTIVE_KEYMAP)
      return prettifyKey(key)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

*[id^='keyMapModal__'][id*='modal_outer'] {
  z-index: 9999 !important;
}
.badge {
  background-color: $quaternary;
  color: $primary;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
}
</style>
